<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> Notice
      </template>
      <b-row>
        <b-col class="mb-3">
          <b-input-group style="width : 45%" size="sm" class="float-right">
            <b-input-group-prepend >
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='title';so.skt='title'">Title</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='contents';so.skt='contents'">Contents</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-input v-model="so.sv" @keyup.enter="refresh()"></b-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template v-slot:id="row">{{row.item.id}}</template>
        <template v-slot:is_use="row">{{row.item.is_use}}</template>
        <template v-slot:title="row">
          <a :href="'javascript:;'" @click="detail(row.item)" size="sm">{{row.item.title}}</a>
        </template>
        <template v-slot:created_at="row">{{row.item.created_at | date}}</template>
      </b-table>

      <b-row>
        <b-col>
        </b-col>
        <b-col class="mt-1 d-flex justify-content-center">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons />
        </b-col>
        <b-col class="md-4" v-if="profile.permission == 'Master'">
          <div class="pull-right">
            <b-button class= "m-1" size="sm" variant="success" @click="$router.push({ name: 'notice', params: { id : 'add' } })"> Register </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { api, auth } from '@/f1/service';
import 'vue2-datepicker/index.css';

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  data: () => ({ so : default_opt(), profile: auth.profile }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', thStyle: 'width: 10%', label: 'No', sortable: true},
        { key: 'is_use', label: 'Enable', sortable: true, thStyle: 'width: 15%'},
        { key: 'title', label: 'Title', sortable: true, thStyle: 'width: 65%' },
        { key: 'created_at', label: 'Created At', sortable: true, thStyle: 'width: 15%'  },
      ]
    }
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || 'title',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, and: [], or: [], sort: [] }
      // order
      if(so.ok) { search.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search
      if(so.sk && so.sv) {
        //search 모드에서 검색할때
        if(!so.ok){
          search.sort.push({name: so.sk, op: so.od == 'd' && 'desc' });
        }
        search.or.push({name: so.sk, value: `%${so.sv}%`, op: 'like' });
      }

      try { let rs = await api.board.notice.list(search); this.so.totalRows = rs.count; return rs.result; }
      catch(e) { this.$toastr.e(e.data || e); }
    },
    detail(item) { this.$router.push(`/boards/notice/${item.id}`); },
  },
  created() { },
  destroyed() { },
  mounted() {  },
}
</script>
